import { render, staticRenderFns } from "./activity-interventions.vue?vue&type=template&id=2c8faacc"
import script from "./activity-interventions.vue?vue&type=script&lang=js"
export * from "./activity-interventions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports